import { render, staticRenderFns } from "./lungcancerFollowupForm.vue?vue&type=template&id=efe09aac&scoped=true"
import script from "./lungcancerFollowupForm.vue?vue&type=script&lang=js"
export * from "./lungcancerFollowupForm.vue?vue&type=script&lang=js"
import style0 from "./lungcancerFollowupForm.vue?vue&type=style&index=0&id=efe09aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe09aac",
  null
  
)

export default component.exports